module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cas":"CAS","sql_editor":"SQL Editor","job_list":"Job List"},"ja":{"cas":"CAS","sql_editor":"SQLエディター","job_list":"ジョブ一覧"}}')
  delete Component.options._Ctor
}
